import React from 'react';
import ItemLocationList from '../warehouse/detail/ItemInLocation/ItemLocationList';

const ItemLocations = () => {
  return <ItemLocationList isIndependentPage />;
};

export default ItemLocations;
